import React from "react";
import { Database, Calendar } from "lucide-react";

/**
 * SVG Icons used in filters
 */
const DatabaseIcon = () => <Database size={18} />;

const CalendarIcon = () => <Calendar size={18} />;

/**
 * ExceptionsRecordFilters Component
 * Encapsulates filter definitions for the exceptions record table
 */
export const ExceptionsRecordFilters = ({ translate, getDynamicFilters }) => {
  return [
    {
      mainFilters: [
        {
          key: "ReconciliationStreamName",
          displayName: translate(
            "exceptions-record.filters.ReconciliationStreamName"
          ),
          icon: DatabaseIcon,
          components: [
            {
              name: translate(
                "exceptions-record.filters.ReconciliationStreamName"
              ),
              type: "title",
              key: "title",
            },
            {
              name: translate("exceptions-record.filters.ReconciliationRunId"),
              type: "numberInput",
              key: "ReconciliationRunId",
              placeHolder: translate("shared.filterRunID"),
              decimalPoint: 0,
              step: 1,
              operator: "EQ",
              filterType: "string",
              hasDecimal: false,
            },
            {
              name: translate(
                "exceptions-record.filters.ReconciliationStreamTag"
              ),
              type: "checkboxGroup",
              key: "ReconciliationStreamTag",
              testKey: "ReconciliationStreamTag",
              values: getDynamicFilters("ReconciliationStreamTag"),
              filterType: "checkbox",
              operator: "EQ",
            },
          ],
        },
        {
          key: "Location",
          displayName: translate("exceptions-record.filters.Location"),
          icon: DatabaseIcon,
          components: [
            {
              name: translate("exceptions-record.filters.Reconciliations"),
              type: "title",
              key: "title",
            },
            {
              name: translate("exceptions-record.filters.AreaId"),
              type: "checkboxGroup",
              key: "AreaId",
              values: getDynamicFilters("AreaId"),
              filterType: "checkbox",
              operator: "EQ",
            },
            {
              name: translate("exceptions-record.filters.OutletId"),
              type: "checkboxGroup",
              key: "OutletId",
              values: getDynamicFilters("OutletId"),
              filterType: "checkbox",
              operator: "EQ",
            },
            {
              name: translate(
                "exceptions-record.filters.TransactionTerminalCode"
              ),
              type: "checkboxGroup",
              key: "TransactionTerminalCode",
              values: getDynamicFilters("TransactionTerminalCode"),
              filterType: "checkbox",
              operator: "EQ",
            },
          ],
        },
        {
          key: "AgingTierTag",
          displayName: translate("exceptions-record.filters.AgingTier"),
          icon: DatabaseIcon,
          components: [
            {
              name: translate("exceptions-record.filters.AgingTier"),
              type: "title",
              key: "title",
            },
            {
              name: translate("exceptions-record.filters.AgingTier"),
              type: "checkboxGroup",
              key: "AgingTierTag",
              values: getDynamicFilters("AgingTierTag"),
              filterType: "checkbox",
              operator: "EQ",
            },
          ],
        },
        {
          key: "NextReconciliationRun",
          displayName: translate("exceptions-record.filters.dates"),
          icon: CalendarIcon,
          components: [
            {
              name: translate("exceptions-record.filters.PleaseSelectDate"),
              type: "title",
              key: "title",
            },
            {
              name: translate("exceptions-record.filters.CreationDate"),
              type: "dateInput",
              inputType: "date",
              key: "CreationDate",
              placeHolder: translate("exceptions-record.filters.CreationDate"),
              prefix: "",
              filterType: "date",
            },
            {
              name: translate("exceptions-record.filters-display.BusinessDay"),
              type: "dateInput",
              inputType: "date",
              key: "BusinessDay",
              placeHolder: translate(
                "exceptions-record.filters-display.BusinessDay"
              ),
              prefix: "",
              filterType: "date",
            },
          ],
        },
        {
          key: "Amounts",
          displayName: translate("exceptions-record.filters.Amounts"),
          icon: DatabaseIcon,
          components: [
            {
              name: translate("exceptions-record.filters.Amounts"),
              type: "title",
              key: "title",
            },
            {
              name: translate("exceptions-record.filters.SourceAmount"),
              type: "numberInput",
              key: "SourceAmount",
              filterType: "amount",
              inputType: "number",
            },
            {
              name: translate("exceptions-record.filters.DestinationAmount"),
              type: "numberInput",
              key: "DestinationAmount",
              filterType: "amount",
              inputType: "number",
            },
          ],
        },
        {
          key: "Mismatches",
          displayName: translate("run-matching-records.filters.Mismatch"),
          icon: DatabaseIcon,
          components: [
            {
              name: translate("run-matching-records.filters.Mismatch"),
              type: "title",
              key: "title",
            },
            {
              name: translate("run-matching-records.filters.Mismatch"),
              type: "checkboxGroup",
              key: "MismatchTag",
              values: getDynamicFilters("MismatchTag"),
              filterType: "checkbox",
              operator: "EQ",
            },
            {
              name: translate("run-matching-records.filters.MismatchSeverity"),
              type: "checkboxGroup",
              key: "MismatchSeverityTag",
              values: getDynamicFilters("MismatchSeverityTag"),
              filterType: "checkbox",
              operator: "EQ",
            },
          ],
        },
      ],
    },
  ];
};
